/**
 * Local Supabase port configuration
 *
 * AUTO-GENERATED by scripts/supabase-ports.ts — do not edit manually.
 * Re-generated on every `bun run setup` or `bun run db:start`.
 */

export const LOCAL_SUPABASE_PORTS = {
  api: 54280,
  db: 54281,
  shadowDb: 54282,
  studio: 54283,
  inbucket: 54284,
  pooler: 54285,
  analytics: 54286,
  analyticsVector: 54287,
};

export const LOCAL_SUPABASE_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.api}`;
export const LOCAL_SUPABASE_STUDIO_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.studio}`;
export const LOCAL_INBUCKET_URL = `http://localhost:${LOCAL_SUPABASE_PORTS.inbucket}`;
